import React, { useEffect, useState } from "react";
import "./App.css";

const App = () => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [activeFAQ, setActiveFAQ] = useState(null);

  useEffect(() => {
    setIsLoaded(true);

    // Smooth scroll behavior
    const handleScroll = () => {
      const elements = document.querySelectorAll(".fade-in-up");
      elements.forEach((element) => {
        const elementTop = element.getBoundingClientRect().top;
        const elementVisible = 150;

        if (elementTop < window.innerHeight - elementVisible) {
          element.classList.add("animate-fade-in-up");
        }
      });
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const toggleFAQ = (index) => {
    setActiveFAQ(activeFAQ === index ? null : index);
  };

  const faqData = [
    {
      question: "Законен ли договор, составленный через бота?",
      answer:
        "Да. ДКП в простой письменной форме полностью соответствует требованиям ГК РФ и действует при подписании сторонами. Мы формируем корректный бланк со всеми реквизитами.",
    },
    {
      question: "Нужен ли нотариус для договора купли‑продажи автомобиля?",
      answer:
        "Нет, нотариальное удостоверение не требуется независимо от стоимости авто. Достаточно подписей продавца и покупателя. Нотариус нужен для сделок с долями в ООО, недвижимостью, наследством — но не для автомобилей.",
    },
    {
      question: "Как правильно подписать договор?",
      answer:
        "Распечатайте 2 экземпляра, подпишите обеими сторонами на каждом листе, укажите дату и место. Рекомендуем добавить отметку \"деньги получены\" и оформить передачу ключей/ПТС в разделе о передаче или отдельным актом.",
    },
    {
      question: "Какие данные и документы нужны для ДКП?",
      answer:
        "Паспорта сторон, СТС и ПТС, VIN, марка/модель, год, цвет, госномер, цена, пробег, дата и место сделки, контакты. Полис ОСАГО для заключения ДКП не обязателен.",
    },
    {
      question: "Сроки постановки на учёт покупателем?",
      answer:
        "Покупатель обязан зарегистрировать авто в ГИБДД в течение 10 дней со дня заключения ДКП. За просрочку возможен штраф, а ездить без регистрации нельзя.",
    },
    {
      question: "Можно ли использовать сервис для юридических лиц?",
      answer:
        "Да. Для организаций указываются реквизиты и данные представителя (на основании устава или доверенности).",
    },
    {
      question: "Что делать, если покупатель не явился или передумал?",
      answer:
        "Если договор не подписан — сделки нет. Назначайте новую дату. Вопрос с задатком/авансом решается условиями, о которых вы договорились (их можно предусмотреть в тексте).",
    },
    {
      question: "Как безопасно оформить расчёт?",
      answer:
        "Лучше безналичный перевод с назначением платежа или расписка/отметка в договоре \"деньги получены\" с суммой и датой. Храните подтверждения расчётов.",
    },
    {
      question: "Можно ли вносить правки в договор?",
      answer:
        "Да — отредактируйте поля перед генерацией. После печати изменения допустимы только с подписью обеих сторон на внесённых правках или оформляйте новый ДКП.",
    },
    {
      question: "Как я получу документ?",
      answer:
        "Вы получаете готовый PDF для печати и подписания. Храните его у себя в бумажном и/или электронном виде.",
    },
  ];

  const testimonials = [
    {
      name: "Андрей Волков",
      role: "Частный продавец",
      text: "Составляю по 15-20 договоров в месяц. Раньше тратил на каждый по полчаса, теперь — 2 минуты. Экономлю кучу времени!",
      avatar: "https://randomuser.me/api/portraits/men/43.jpg",
    },
    {
      name: "Мария Петрова",
      role: "Автосалон 'Премиум Авто'",
      text: "Клиенты довольны скоростью оформления. Никаких ошибок в документах, все четко и профессионально.",
      avatar: "https://i.pravatar.cc/150?img=47",
    },
    {
      name: "Дмитрий Сидоров",
      role: "Частный продавец",
      text: "Продавал машину впервые, боялся ошибиться с документами. Бот составил все идеально, сделка прошла гладко.",
      avatar: "https://randomuser.me/api/portraits/men/32.jpg",
    },
  ];

  return (
    <div className="App min-h-screen bg-gradient-to-br from-slate-900 via-blue-900 to-slate-900">
      {/* SEO Meta Tags */}
      <div style={{ display: "none" }}>
        <h1>
          Договор купли-продажи автомобиля онлайн — через Telegram за 1 минуту
        </h1>
        <meta
          name="description"
          content="Быстрое оформление ДКП автомобиля через Telegram-бота. Без ошибок, готовый PDF за 1 минуту. Первый договор бесплатно!"
        />
      </div>

      {/* Hero Section */}
      <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-br from-blue-900/20 to-slate-900/80"></div>
        <div
          className="absolute inset-0 bg-cover bg-center opacity-20"
          style={{
            backgroundImage: `url('https://images.unsplash.com/photo-1648822145238-16e13a1591da')`,
          }}
        ></div>

        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div
            className={`transition-all duration-1000 ${isLoaded ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}
          >
            <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight">
              Договор купли-продажи
              <br />
              <span className="bg-gradient-to-r from-blue-400 to-cyan-400 bg-clip-text text-transparent">
                автомобиля онлайн
              </span>
            </h1>
            <p className="text-xl md:text-2xl text-blue-100 mb-8 max-w-3xl mx-auto">
              Через Telegram за 1 минуту • Без ошибок • Готовый PDF для печати
            </p>

            <div className="backdrop-blur-lg bg-white/10 rounded-3xl p-8 mb-8 border border-white/20 max-w-md mx-auto">
              <div className="text-white mb-4">
                <svg
                  className="w-16 h-16 mx-auto mb-4 text-blue-400"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"
                  />
                </svg>
                <h3 className="text-xl font-semibold mb-2">
                  Telegram-бот готов к работе
                </h3>
                <p className="text-blue-200 text-sm">
                  Сфотографируй документы → Получи готовый договор
                </p>
              </div>

              <a
                href="https://t.me/gdepts_bot?start=site"
                target="_blank"
                rel="noopener noreferrer"
                className="w-full bg-gradient-to-r from-blue-500 to-cyan-500 text-white font-bold py-4 px-8 rounded-xl hover:from-blue-600 hover:to-cyan-600 transform hover:scale-105 transition-all duration-300 shadow-2xl hover:shadow-blue-500/25 inline-block"
              >
                🚀 Запустить бота бесплатно
              </a>
            </div>

            <div className="flex items-center justify-center space-x-8 text-blue-200">
              <div className="flex items-center">
                <svg
                  className="w-5 h-5 mr-2 text-green-400"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M5 13l4 4L19 7"
                  ></path>
                </svg>
                Первый договор бесплатно
              </div>
              <div className="flex items-center">
                <svg
                  className="w-5 h-5 mr-2 text-green-400"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                  ></path>
                </svg>
                Доступно 24/7
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* How It Works Section */}
      <section className="py-20 bg-gradient-to-r from-slate-800 to-blue-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16 fade-in-up">
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
              Как это работает
            </h2>
            <p className="text-xl text-blue-200 max-w-2xl mx-auto">
              Простой процесс из трех шагов — и ваш договор готов
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            {[
              {
                step: "01",
                title: "Сфотографируй",
                description:
                  "Паспорта и СТС/ПТС — это все, что нужно для составления договора",
                image: "/images/step-1-v2.jpg?v=4",
              },
              {
                step: "02",
                title: "Отправь",
                description:
                  "Бот автоматически извлечет все данные и заполнит договор",
                image: "/images/step-2-v2.jpg?v=4",
              },
              {
                step: "03",
                title: "Получи готовый PDF",
                description:
                  "Договор готов к печати и полностью соответствует законодательству РФ",
                image: "/images/step-3-v2.jpg?v=4",
              },
            ].map((item, index) => (
              <div
                key={index}
                className="relative group fade-in-up"
                style={{ animationDelay: `${index * 200}ms` }}
              >
                <div className="backdrop-blur-lg bg-white/10 rounded-3xl p-8 border border-white/20 hover:bg-white/20 transition-all duration-300 transform hover:-translate-y-2">
                  <div
                    className="w-full h-48 rounded-2xl mb-6 bg-cover bg-center opacity-60 group-hover:opacity-80 transition-opacity duration-300"
                    style={{ backgroundImage: `url('${item.image}')` }}
                  ></div>

                  <div className="text-4xl mb-4">{item.icon}</div>
                  <div className="text-sm font-bold text-blue-400 mb-2">
                    ШАГ {item.step}
                  </div>
                  <h3 className="text-2xl font-bold text-white mb-4">
                    {item.title}
                  </h3>
                  <p className="text-blue-200">{item.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section className="py-20 bg-gradient-to-br from-blue-900 to-slate-900">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16 fade-in-up">
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
              Почему выбирают наш бот
            </h2>
            <p className="text-xl text-blue-200 max-w-2xl mx-auto">
              Все преимущества современного подхода к оформлению документов
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {[
              {
                icon: "⚡",
                title: "Без ошибок и шаблонов",
                description:
                  "ИИ автоматически заполняет данные из документов, исключая человеческий фактор",
              },
              {
                icon: "🖨️",
                title: "Документ готов к печати",
                description:
                  "PDF высокого качества с правильным форматированием для любого принтера",
              },
              {
                icon: "🆓",
                title: "Первый договор бесплатно",
                description:
                  "Попробуйте сервис без риска — оцените качество и удобство",
              },
              {
                icon: "👤",
                title: "Подходит для физ. лиц",
                description:
                  "Идеально для частных продавцов и покупателей автомобилей",
              },
              {
                icon: "📱",
                title: "Доступно 24/7 с телефона",
                description:
                  "Составляйте договоры в любое время прямо со смартфона",
              },
              {
                icon: "⚖️",
                title: "Соответствует ГК РФ",
                description:
                  "Полное соответствие требованиям российского законодательства",
              },
            ].map((benefit, index) => (
              <div
                key={index}
                className="backdrop-blur-lg bg-white/10 rounded-3xl p-6 border border-white/20 hover:bg-white/20 transition-all duration-300 transform hover:scale-105 fade-in-up"
                style={{ animationDelay: `${index * 100}ms` }}
              >
                <div className="text-4xl mb-4">{benefit.icon}</div>
                <h3 className="text-xl font-bold text-white mb-3">
                  {benefit.title}
                </h3>
                <p className="text-blue-200">{benefit.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      <section className="py-20 bg-gradient-to-r from-slate-800 to-blue-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16 fade-in-up">
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
              Отзывы клиентов
            </h2>
            <p className="text-xl text-blue-200">
              Узнайте, что говорят о нас профессионалы авторынка
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            {testimonials.map((testimonial, index) => (
              <div
                key={index}
                className="backdrop-blur-lg bg-white/10 rounded-3xl p-8 border border-white/20 hover:bg-white/20 transition-all duration-300 fade-in-up"
                style={{ animationDelay: `${index * 200}ms` }}
              >
                <div className="flex items-center mb-6">
                  <img
                    src={testimonial.avatar}
                    alt={testimonial.name}
                    className="w-16 h-16 rounded-full object-cover mr-4"
                  />
                  <div>
                    <h4 className="text-lg font-bold text-white">
                      {testimonial.name}
                    </h4>
                    <p className="text-blue-300 text-sm">{testimonial.role}</p>
                  </div>
                </div>
                <p className="text-blue-100 italic">"{testimonial.text}"</p>
                <div className="flex mt-4">
                  {[...Array(5)].map((_, i) => (
                    <svg
                      key={i}
                      className="w-5 h-5 text-yellow-400"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                    >
                      <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path>
                    </svg>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="py-20 bg-gradient-to-br from-blue-900 to-slate-900">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16 fade-in-up">
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
              Часто задаваемые вопросы
            </h2>
            <p className="text-xl text-blue-200">
              Ответы на самые популярные вопросы о договорах купли-продажи
            </p>
          </div>

          <div className="space-y-4">
            {faqData.map((faq, index) => (
              <div
                key={index}
                className="backdrop-blur-lg bg-white/10 rounded-2xl border border-white/20 overflow-hidden fade-in-up"
                style={{ animationDelay: `${index * 100}ms` }}
              >
                <button
                  onClick={() => toggleFAQ(index)}
                  className="w-full px-8 py-6 text-left hover:bg-white/10 transition-colors duration-200 flex justify-between items-center"
                >
                  <h3 className="text-lg font-semibold text-white pr-8">
                    {faq.question}
                  </h3>
                  <svg
                    className={`w-6 h-6 text-blue-400 transition-transform duration-200 ${activeFAQ === index ? "transform rotate-180" : ""}`}
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M19 9l-7 7-7-7"
                    ></path>
                  </svg>
                </button>
                {activeFAQ === index && (
                  <div className="px-8 py-6 border-t border-white/10">
                    <p className="text-blue-200">{faq.answer}</p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* SEO Content Section */}
      <section className="py-20 bg-gradient-to-r from-slate-800 to-blue-800">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="backdrop-blur-lg bg-white/10 rounded-3xl p-8 border border-white/20 fade-in-up">
            <h2 className="text-3xl font-bold text-white mb-6">
              Как оформить договор купли-продажи авто быстро и без ошибок
            </h2>
            <div className="prose prose-lg text-blue-100 max-w-none">
              <p className="mb-4">
                <strong>ДКП онлайн</strong> через наш Telegram-бот — это
                современное решение для тех, кто ценит время и качество.
                Традиционное оформление{" "}
                <strong>договора купли-продажи машины</strong> требует знания
                всех тонкостей законодательства, но с нашим{" "}
                <strong>ботом для ДКП</strong> этот процесс становится простым и
                быстрым.
              </p>
              <p className="mb-4">
                Наш сервис создает{" "}
                <strong>договор купли-продажи автомобиля образец</strong>{" "}
                которого полностью соответствует требованиям ГК РФ. Вам больше
                не нужно искать шаблоны в интернете или обращаться к юристам —
                все происходит автоматически на основе данных из ваших
                документов.
              </p>
              <p>
                Попробуйте наш сервис прямо сейчас и убедитесь, насколько просто
                может быть оформление автомобильных сделок в цифровую эпоху.
                Первый договор — бесплатно!
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Final CTA Section */}
      <section className="py-20 bg-gradient-to-br from-blue-900 to-slate-900">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="backdrop-blur-lg bg-white/10 rounded-3xl p-12 border border-white/20 fade-in-up">
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
              Готовы составить договор?
            </h2>
            <p className="text-xl text-blue-200 mb-8">
              Присоединяйтесь к тысячам довольных клиентов, которые уже оценили
              удобство нашего сервиса
            </p>
            <a
              href="https://t.me/gdepts_bot?start=site"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block bg-gradient-to-r from-blue-500 to-cyan-500 text-white font-bold py-4 px-12 rounded-xl hover:from-blue-600 hover:to-cyan-600 transform hover:scale-105 transition-all duration-300 shadow-2xl hover:shadow-blue-500/25 text-lg"
            >
              🚀 Начать прямо сейчас
            </a>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-slate-900 py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-3 gap-8 mb-8">
            <div>
              <h3 className="text-xl font-bold text-white mb-4">
                Договор ДКП Бот
              </h3>
              <p className="text-blue-200 mb-4">
                Быстрое и надежное оформление договоров купли-продажи
                автомобилей через Telegram
              </p>
              <a
                href="https://t.me/gdepts_bot?start=site"
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-400 hover:text-blue-300 transition-colors"
              >
                @gdepts_bot
              </a>
            </div>

            <div>
              <h4 className="text-lg font-semibold text-white mb-4">Услуги</h4>
              <ul className="space-y-2 text-blue-200">
                <li>Составление ДКП</li>
                <li>Проверка документов</li>
                <li>Консультации по сделкам</li>
                <li>Поддержка 24/7</li>
              </ul>
            </div>

            <div>
              <h4 className="text-lg font-semibold text-white mb-4">
                Контакты
              </h4>
              <ul className="space-y-2 text-blue-200">
                <li>
                  <a
                    href="mailto:hello@next3.ai"
                    className="hover:text-blue-300 transition-colors"
                  >
                    hello@next3.ai
                  </a>
                </li>
                <li>
                  <a href="#" className="hover:text-blue-300 transition-colors">
                    Политика конфиденциальности
                  </a>
                </li>
              </ul>
            </div>
          </div>

          <div className="border-t border-slate-700 pt-8 text-center">
            <p className="text-blue-300">
              © 2025 Договор ДКП Бот. Все права защищены.
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default App;
